/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React from 'react';


const RefactorAccount = ({data}) => {
const [blocked, setBlocked] = React.useState(false);
  
  return (  
      <div className='container'>
      <div className ='wrapper wrapper-flex '>
          <div className="size-12 ">
          <div className="card">
            <div className='form-row hdr_transaction'>
              <div className='col-ico '>
                <i className="ibon-card inb4"></i>
              </div>
              <h2 className='col-5'>
                Cuentas
              </h2>
              <div className="flex align-center pnl-botonera-2">
                <div className={`switcher mini padding-right desktop ${blocked ? 'active' : ''}`} >
                  <div className="switcherSlider">
                    <div className="switcherSliderCircle">
                    </div>
                  </div>
                  <label className='col-3 fix-lb-spaces-bloq'>Bloquear</label>
                </div>
                <div className=" bigButton secundary padding-right desktop">
                  <button>
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
 
            <div className='table-content'>
              <table>
                <tbody>
                  <tr>
                    <th>
                    </th>
                    <th className="neutral">Número de cuenta <i className="tap ibon-chevron-down"></i></th>
                    <th className="neutral">Tipo de cuenta <i className="tap ibon-chevron-down"></i></th>
                    <th className="neutral">Estatus <i className="tap ibon-chevron-down"></i></th>
                    <th className="neutral">Tarjetas <i className="tap ibon-chevron-down"></i></th>
                    <th className="neutral"></th>
                  </tr>
                  <tr className='init_data'>
                    <td>
                      <div className='radio_in_table'>
                        <input className='cmn_radio' type="radio" id="radio1"/>
                        <label htmlFor="radio1"></label>
                      </div>
                    </td>
                    <td>120000000001902</td>
                    <td>Débito</td>
                    <td>enabled</td>
                    <td>1</td>
                    <td></td>
                  </tr>
                  <tr className='complement-data-index show'>
                    <td></td>
                    <td colSpan={4}> 
                      <div className='size-6' >
                      </div>
                    </td>
                  </tr>
              </tbody>
              </table>
            </div> 
          </div>
        </div>
      </div>
    </div>
    
    
        
  );
}

export default RefactorAccount;